import { configureStore } from '@reduxjs/toolkit'
import notificationsSlice from './notificationSlice'
import fundSeriesReducer from './fundSeriesSlice'

export const store = configureStore({
  reducer: {
    notification: notificationsSlice,
    fundSeries: fundSeriesReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
